exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".company .pw{width:980px!important;margin:0 auto}.company .w780{width:680px!important}.company .w380{width:280px!important}", ""]);

// exports
